"use client";

import { ReactNode, useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { initI18next, localeNameSpaces } from "@payping/utils/localeUtils";
import { localeResources } from "../assets/locales/resources";
import Wrapper from "../components/Wrapper";

export function RootProvider({ children }: { children: ReactNode }) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-MSN6P6G" });
    initI18next(localeNameSpaces.Wrapper, localeResources);
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoading(false);
  }, []);

  if (loading) return <>...</>;

  return <Wrapper>{children}</Wrapper>;
}
